export default __webpack_public_path__ + "static/media/return.6a5d0163.svg";